import { createContext, useContext, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

const SlotContext = createContext<{
  element: HTMLElement | null;
  setElement: (element: HTMLElement | null) => void;
} | null>(null);

/**
 * Lets the pages inside an area layout (e.g. Völker · Behandlungen) put their
 * primary action next to the area's title (docs/ux-richtlinien.md §4).
 */
export function PageActionsProvider({ children }: { children: ReactNode }) {
  const [element, setElement] = useState<HTMLElement | null>(null);
  return <SlotContext.Provider value={{ element, setElement }}>{children}</SlotContext.Provider>;
}

/** Where the actions appear; place it in the layout's `PageHeader` actions. */
export function PageActionsSlot() {
  const slot = useContext(SlotContext);
  return <span ref={(el) => slot?.setElement(el)} style={{ display: 'contents' }} />;
}

/** Renders its children into the layout's slot (or in place without one). */
export function PageActions({ children }: { children: ReactNode }) {
  const slot = useContext(SlotContext);
  if (!slot) return <>{children}</>;
  return slot.element ? createPortal(children, slot.element) : null;
}
